/**
 * Logging de depuración para el módulo Formulario Master, apagado por defecto.
 * Se activa poniendo en la consola del navegador `window.SIRIO_DEBUG_FORM_MASTER = true`,
 * o en build/desarrollo con la variable de entorno REACT_APP_DEBUG_FORM_MASTER=true.
 * Mismo patrón que DEBUG_EVALUATE en evaluateMenuRelevant.js.
 */
export const isFormMasterDebugEnabled = () =>
  (typeof window !== 'undefined' && Boolean(window?.SIRIO_DEBUG_FORM_MASTER)) ||
  (typeof process !== 'undefined' && process?.env?.REACT_APP_DEBUG_FORM_MASTER === 'true');

export const debugLog = (...args) => {
  if (isFormMasterDebugEnabled()) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export default debugLog;
